export const groupByOptions = [
  { value: "statusName", label: "Status" },
  { value: "priorityName", label: "Priority" },
  { value: "assigneeName", label: "Assignee" },
];

export const boardColumns = [
  { value: "To Do", label: "To Do" },
  { value: "In Progress", label: "In Progress" },
  { value: "Done", label: "Done" },
];
